import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

export interface EmptyIndicatorProps {
  children?: React.ReactNode;
  description?: string;
  descriptionStyle?: React.CSSProperties;
  icon: IconProp;
  iconIsDarker?: boolean;
  iconStyle?: React.CSSProperties;
  size?: 'small';
  style?: React.CSSProperties;
  title: string | React.ReactNode;
  titleStyle?: React.CSSProperties;
}

const EmptyIndicator = ({
  children,
  description,
  descriptionStyle,
  icon,
  iconIsDarker,
  iconStyle,
  size,
  style,
  title,
  titleStyle
}: EmptyIndicatorProps) => {
  const { theme } = useReduxState();

  let padding = '50px';
  let iconSize = '60px';
  let iconFontSize = '2rem';
  let iconPadding = '17px 0';
  let titleFontSize = '1.6rem';
  let titleMargin = '10px 0 5px';
  let descriptionFontSize = '1.5rem';

  if (size === 'small') {
    padding = '25px';
    iconSize = '40px';
    iconFontSize = '1.4rem';
    iconPadding = '11px 0';
    titleFontSize = '1.5rem';
    titleMargin = '5px 0 1px';
    descriptionFontSize = '1.4rem';
  }

  return (
    <div className="empty" style={style}>
      <div className="icon" style={iconStyle}>
        <Icon icon={icon} />
      </div>
      <div className="title" style={titleStyle}>
        {title}
      </div>

      {description ? (
        <p className="description" style={descriptionStyle}>
          {description}
        </p>
      ) : null}

      {children ? <div className="content">{children}</div> : null}

      <style jsx>{`
        .empty {
          padding: ${padding};
          text-align: center;
        }
        .icon {
          background-color: ${iconIsDarker
            ? theme.lightGreyDark
            : theme.lightGrey};
          border-radius: 50%;
          color: #999;
          display: inline-block;
          font-size: ${iconFontSize};
          height: ${iconSize};
          margin: 0;
          padding: ${iconPadding};
          width: ${iconSize};
        }
        .title {
          color: ${theme.textColorLighter};
          font-size: ${titleFontSize};
          font-weight: 700;
          margin: ${titleMargin};
        }
        .description {
          color: ${theme.textColorLighter};
          display: inline-block;
          font-size: ${descriptionFontSize};
          font-weight: 400;
          margin: 0;
        }
        .content {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default EmptyIndicator;
